import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import GreetingCard from "../../../components/hrm/attendance/employee-attendance/GreetingCard";
import StatsCard from "../../../components/hrm/attendance/employee-attendance/StatsCard";
import WorkingHours from "../../../components/hrm/attendance/employee-attendance/WorkingHoursCard";
import AttendanceHeader from "../../../components/hrm/attendance/employee-attendance/AttendanceHeader";
import { FiClock, FiCalendar, FiBriefcase } from "react-icons/fi";
import AttendanceTable from "../../../components/hrm/attendance/employee-attendance/AttendanceTable";
export default function EmployeeAttendancePage() {
  const [range, setRange] = useState("Today");

  return (
    <Container fluid style={{ background: "#f4f5f7", padding: 20 }}>
      <AttendanceHeader/>
      <Row className="g-3">
        
        {/* LEFT CARD */}
        <Col lg={3}>
          <GreetingCard />
        </Col>

        {/* RIGHT SIDE */}
        <Col lg={9}>
          
          {/* TOP STATS */}

<Row className="">
  <div className="stats-container">
      <StatsCard
        value="8.36"
        total="9"
        label="Total Hours Today"
        icon={<FiClock color="#fff" size={16} />}
        iconBg="#ff7a1a"
        trendText="5% This Week"
        trendType="up"
      />

      <StatsCard
        value="10"
        total="40"
        label="Total Hours Week"
        icon={<FiClock color="#fff" size={16} />}
        iconBg="#1f2937"
        trendText="7% Last Week"
        trendType="up"
      />

      <StatsCard
        value="75"
        total="98"
        label="Total Hours Month"
        icon={<FiClock color="#fff" size={16} />}
        iconBg="#2563eb"
        trendText="8% Last Month"
        trendType="down"
      />

      <StatsCard
        value="16"
        total="28"
        label="Overtime this Month"
        icon={<FiClock color="#fff" size={16} />}
        iconBg="#ec4899"
        trendText="6% Last Month"
        trendType="down"
      />
    </div>
</Row>
          {/* WORKING HOURS */}
          <Row className="mt-3">
            <Col>
              <WorkingHours range={range} setRange={setRange} />
            </Col>
          </Row>

          

        </Col>
      </Row>

      <style>
        {
          `
          .card {
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
  .stats-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  // padding: 10px;
}

/* Card */
.stats-card {
  background: #ffffff;
  border-radius: 6px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  position: relative;
  transition: 0.2s ease;
}

.stats-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* Icon */
.icon-box {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

/* Value */
.value {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.value span {
  font-size: 18px;
  color: #6b7280;
  font-weight: 500;
}

/* Label */
.label {
  font-size: 14px;
  color: #6b7280;
  margin-top: 4px;
}

/* Divider */
.divider {
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0;
}

/* Trend */
.trend {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
}

/* Trend Icon */
.trend-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

.trend-icon.up {
  background: #16a34a;
}

.trend-icon.down {
  background: #dc2626;
}

/* 📱 Mobile Responsive */
@media (max-width: 992px) {
  .stats-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .stats-container {
    grid-template-columns: 1fr;
  }

  .value {
    font-size: 22px;
  }
}
          `
        }
      </style>
      <AttendanceTable/>
    </Container>
  );
}